import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import FormikDropdown from 'components/inputs/FormikDropDown';
import FormikTextInput from 'components/inputs/FormikInputs';
import { addUserSchema, updateUserSchema } from 'utils/schema/userSchema';
import { useDispatch, useSelector } from 'react-redux';
import { ADD_USER, FETCH_USER, UNSET_USER, UPDATE_USER } from 'actions/userActions';
import { useParams, useNavigate } from 'react-router-dom';
import { IconUserPlus, IconCheck } from '@tabler/icons-react';
import 'view/allForms/AllForms.scss';

const defaultValues = {
  name: '',
  lastName: '',
  email: '',
  phone: '',
  password: '',
  confirmPassword: '',
  role: '',
};
const User = () => {
  const { userId = '' } = useParams();
  const navigate = useNavigate();
  const [formInitialValues, setFormInitialValues] = useState(defaultValues);

  const { user: userData } = useSelector((state) => state.users);

  useEffect(() => {
    if (userId !== '') {
      fetchUser(userId);
    } else {
      setFormInitialValues(defaultValues);
    }

    return () => {
      dispatch({ type: UNSET_USER });
    };
  }, [userId]);

  useEffect(() => {
    if (userData !== null) {
      setFormInitialValues({
        name: userData.name,
        lastName: userData.lastName,
        email: userData.email,
        phone: userData.phone,
        password: '',
        confirmPassword: '',
        role: userData.role,
      });
    }
  }, [JSON.stringify(userData)]);

  const dispatch = useDispatch();
  const options = [
    { label: 'Admin', value: 'admin' },
    { label: 'Engineer', value: 'engineer' },
    { label: 'Contractor', value: 'contractor' },
    { label: 'CZ Quality', value: 'quality' },
    { label: 'CZ Manager', value: 'manager' },
  ];

  const submitForm = (values) => {
    try {
      delete values.confirmPassword;
      if (userId !== '') {
        delete values.role;
        if (values.password === '') {
          delete values.password;
        }
        dispatch({ type: UPDATE_USER, payload: { userId, values } });
      } else {
        dispatch({ type: ADD_USER, payload: values });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const formik = useFormik({
    initialValues: formInitialValues,
    validationSchema: userId !== '' ? updateUserSchema : addUserSchema,
    onSubmit: submitForm,
    enableReinitialize: true,
  });

  const fetchUser = (userId) => {
    dispatch({ type: FETCH_USER, payload: userId });
  };

  return (
    <div className="all-forms-page">
      <div className="page-body">
        <div className="container-xl new_application">
          <div className="glass-panel p-5">
            <div className="d-flex align-items-center gap-3 mb-5 border-bottom pb-3">
              <IconUserPlus size={32} className="text-primary" />
              <h2 className="m-0 fw-bold">{userId !== '' ? 'Edit User Profile' : 'Create New User'}</h2>
            </div>

            <form onSubmit={formik.handleSubmit}>
              <div className="row mb-4">
                <div className="col-md-6 mb-3">
                  <FormikTextInput type="text" className="premium-input form-control shadow-none" isRequired label="First Name" name="name" formik={formik} />
                </div>
                <div className="col-md-6 mb-3">
                  <FormikTextInput label="Last Name" isRequired type="text" className="premium-input form-control shadow-none" name="lastName" formik={formik} />
                </div>
              </div>

              <div className="row mb-4">
                <div className="col-md-6 mb-3">
                  <FormikTextInput type="text" className="premium-input form-control shadow-none" label="Phone Number" isRequired name="phone" formik={formik} />
                </div>
                <div className="col-md-6 mb-3">
                  <FormikTextInput type="email" className="premium-input form-control shadow-none" label="Email Address" isRequired name="email" formik={formik} />
                </div>
              </div>

              <div className="row mb-4">
                <div className="col-md-6 mb-3">
                  <FormikTextInput type="password" className="premium-input form-control shadow-none" label="Password" isRequired name="password" formik={formik} />
                </div>
                <div className="col-md-6 mb-3">
                  <FormikTextInput type="password" className="premium-input form-control shadow-none" label="Confirm Password" isRequired name="confirmPassword" formik={formik} />
                </div>
              </div>

              <div className="row mb-4">
                <div className="col-md-6 mb-3">
                  <FormikDropdown
                    label="User Role"
                    readOnly={userId !== ''}
                    placeholder="Select a Role"
                    options={options}
                    isRequired
                    name="role"
                    formik={formik}
                    className="premium-input premium-select form-control shadow-none"
                  />
                </div>
              </div>

              <div className="d-flex justify-content-end gap-3 mt-5 pt-4 border-top">
                <button type="button" className="btn premium-btn-secondary px-4" onClick={() => navigate(-1)}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary premium-btn px-4 d-flex align-items-center gap-2" disabled={formik.isSubmitting}>
                  <IconCheck size={20} stroke={2.5} /> {userId !== '' ? 'Save Changes' : 'Create User'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default User;
